import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function Share(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox ?? '0 0 24 24'}
            style={props.style}
            className={props.className}
        >
            <g>
                <path
                    d="M18.6666 24.0001H5.33332C3.90883 24.0001 2.56952 23.4454 1.56212 22.438C0.554771 21.4307 0 20.0914 0 18.6668V17.3334C0 16.597 0.596923 16 1.33334 16C2.06976 16 2.66668 16.597 2.66668 17.3334V18.6668C2.66668 19.3791 2.94409 20.0487 3.44767 20.5523C3.9514 21.056 4.62103 21.3335 5.33332 21.3335H18.6666C19.3789 21.3335 20.0485 21.056 20.5522 20.5523C21.0559 20.0486 21.3333 19.379 21.3333 18.6668V17.3334C21.3333 16.597 21.9302 16 22.6666 16C23.403 16 24 16.597 24 17.3334V18.6668C24 20.0913 23.4452 21.4305 22.4378 22.438C21.4304 23.4454 20.0911 24.0001 18.6666 24.0001Z"
                    fill="currentColor"
                />
                <path
                    d="M11.4803 0.104549C11.6401 0.0368748 11.8157 -0.000572205 12.0001 -0.000572205C12.1833 -0.000572205 12.3578 0.036314 12.5167 0.103245L12.5181 0.103849L12.5194 0.10441C12.6509 0.159836 12.7753 0.237478 12.8869 0.337059C12.9021 0.350567 12.9171 0.364538 12.9317 0.378838L12.9343 0.381447L12.9351 0.382191L12.9372 0.384241L12.9385 0.385592L12.94 0.387035L12.9429 0.389921L18.2763 5.72324C18.797 6.24392 18.797 7.08821 18.2763 7.60888C17.7557 8.12956 16.9113 8.12956 16.3906 7.60888L13.3335 4.55175V17.3327C13.3335 18.0691 12.7365 18.666 12.0001 18.666C11.2637 18.666 10.6668 18.0691 10.6668 17.3327V4.55171L7.60965 7.60888C7.08897 8.12961 6.24468 8.12956 5.724 7.60888C5.20333 7.08816 5.20333 6.24392 5.724 5.72324L11.0574 0.38983L11.0603 0.386942L11.0617 0.385498L11.0631 0.384148L11.0652 0.382097L11.0659 0.381353L11.0687 0.378653C11.1912 0.258999 11.3313 0.167521 11.4803 0.104549Z"
                    fill="currentColor"
                />
            </g>
        </Icon>
    );
}
